import React, { useState, useEffect } from 'react';
import LoginModalLock from '../content-lock-modals/LoginModalLock';
import PrintContentLock from '../content-lock-modals/PrintContentLock';

const PrintAccessHandler = () => {
  const [hasPrintAccess, setHasPrintAccess] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    if (window.crm_user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }

    // Check if "print" access exists in window.crm_user.access array
    if (Array.isArray(window.crm_user?.access) && window.crm_user?.access.includes('print')) {
      setHasPrintAccess(true);
    } else {
      setHasPrintAccess(false);
    }
  }, []);

  return <>{isLoggedIn ? <PrintContentLock isOpen={!hasPrintAccess} /> : <LoginModalLock isOpen={!isLoggedIn} />}</>;
};

export default PrintAccessHandler;
